import React from 'react';
import * as Accordion from '@radix-ui/react-accordion';
import AccordionCard from './components/AccordionCard/AccordionCard';
import { AccordionSectionStoryblok } from '../../types/storyblok';
import { Box } from '../../base/Box/Box';
import { Type } from '../../base/Type/Type';

const AccordionSection = ({
  subheading,
  Title,
  AccordionCards,
  colourScheme = 'white',
  overlayOverBkg,
}: AccordionSectionStoryblok) => {
  return (
    <Box
      as="section"
      colourScheme={colourScheme || 'white'}
      blockSpacing
      bkg
      overlayOverBkg={overlayOverBkg}
    >
      <Box as="div" className="mx-auto max-w-standard">
        <Type as="h2" typography="subheading">
          {subheading}
        </Type>
        <Type as="h2" className="mb-7 font-helvetica text-h2">
          {Title}
        </Type>
      </Box>
      <Box as="div" blockSpacing>
        <Box as="div" className="mx-auto max-w-wide">
          <Accordion.Root className="" type="single" collapsible>
            {AccordionCards?.map((card) => (
              <AccordionCard
                component="AccordionCard"
                _uid={card?._uid}
                key={card?._uid}
                title={card?.Title}
                richText={card?.richText}
                value={card?._uid}
              />
            ))}
          </Accordion.Root>
        </Box>
      </Box>
    </Box>
  );
};

export default AccordionSection;
